export default "__VITE_ASSET__W3e3w68k__"